import { latLng } from 'leaflet';
import { loc_equal } from 'shared/map/lib/utils';
export function getAngle(context, prev_position, position) {
    if (prev_position == null || position == null) {
        return 0;
    }
    const prev_loc = context.map.options.crs?.project(latLng(prev_position));
    const loc = context.map.options.crs?.project(latLng(position));
    if (loc == undefined || prev_loc == undefined) {
        return 0;
    }
    return (Math.atan2(loc.x - prev_loc.x, loc.y - prev_loc.y) / Math.PI) * 180;
}
function strongMem(f) {
    const cache = {};
    return (arg) => {
        if (arg in cache) {
            return cache[arg];
        }
        const result = f(arg);
        cache[arg] = result;
        return result;
    };
}
function weakMem(f) {
    const cache = new WeakMap();
    return (arg) => {
        if (cache.has(arg)) {
            return cache.get(arg);
        }
        const result = f(arg);
        cache.set(arg, result);
        return result;
    };
}
const _lastGPS2Position = (last_gps) => {
    const position = last_gps[0];
    let prev_position = null;
    if (last_gps.length > 1) {
        let i = 1;
        while (i < last_gps.length && loc_equal(position, last_gps[i]))
            i++;
        if (i < last_gps.length) {
            prev_position = last_gps[i];
        }
    }
    return [prev_position, position];
};
export const lastGPS2Position = weakMem(_lastGPS2Position);
export const onDeviceMarkerClick = weakMem((onClick) => strongMem((device_id) => (ev) => onClick?.(device_id, ev)));
